export const starIcons = [
    {
        id: 0,
        viewBox: "0 0 877 902"
    },
    {
        id: 1,
        name: "large",
        d: "M239.015381,658.986755 C234.668411,666.859741 230.360794,674.354309 226.029404,681.835083 C223.890457,685.529175 220.907822,688.009888 216.428619,686.738342 C211.904373,685.454102 209.812775,682.219482 209.964401,677.366211 C210.388550,663.789978 210.526871,650.204346 211.007141,636.630493 C211.531876,621.799011 212.294937,606.975830 212.988205,592.150574 C213.627136,578.487305 214.260788,564.823364 214.991379,551.164795 C215.579727,540.165466 216.362473,529.176636 216.962662,518.177917 C217.689728,504.853699 218.269913,491.521515 218.999344,478.197479 C219.592316,467.366119 220.137756,456.527557 221.019730,445.717926 C222.080795,432.713562 223.525909,419.740601 224.609955,406.737823 C224.680130,405.896179 223.195953,404.261078 222.244781,404.097015 C205.998276,401.295319 189.738190,398.561768 173.447403,396.029999 C155.498672,393.240570 137.543350,390.462677 119.538277,388.077057 C106.600952,386.362885 93.576492,385.307739 80.592361,383.944794 C74.270248,383.281158 67.942123,382.660950 61.634850,381.875488 C58.136971,381.439911 56.471870,378.769562 56.118156,375.714630 C55.713932,372.223480 55.379787,368.589203 59.762810,366.567139 C69.956276,361.864563 80.424263,357.551453 90.028275,351.819305 C110.426926,339.644379 130.417603,326.777893 150.438202,313.980042 C166.008942,304.026703 181.323425,293.673309 196.841202,283.635925 C211.286087,274.292480 225.861542,265.151062 240.326767,255.838699 C241.130386,255.321350 241.858231,254.087112 241.934525,253.131714 C242.705383,243.477371 243.414444,233.816376 243.982986,224.147964 C245.045822,206.073242 245.963837,187.990005 247.021194,169.914948 C247.596893,160.073639 248.167603,150.226990 249.036942,140.409012 C250.564362,123.158813 252.338272,105.930557 253.970490,88.689476 C254.695511,81.031166 255.162521,73.344925 256.048828,65.706429 C256.869537,58.633507 257.485016,51.432137 259.439453,44.646976 C260.219879,41.937637 264.037750,39.145279 267.025940,38.262447 C271.137604,37.047707 274.949219,39.619812 276.966675,43.390125 C281.818604,52.457764 286.393799,61.676331 290.953827,70.896744 C301.173004,91.560204 311.230682,112.303902 321.514648,132.934891 C329.944580,149.846451 338.592682,166.649414 347.193237,183.475388 C347.832672,184.726379 348.868561,185.774719 349.717346,186.912994 C373.449036,172.599655 397.009735,157.991577 420.969757,144.070724 C442.338226,131.655579 464.159485,120.020554 485.756775,107.997856 C492.756592,104.101234 499.559052,99.830040 506.688965,96.195427 C510.311066,94.348969 514.524780,93.611076 518.151733,96.646187 C521.929626,99.807556 521.117004,104.029610 519.647644,107.725990 C516.053223,116.768448 511.940948,125.603661 508.129303,134.561508 C503.372314,145.741013 499.008820,157.098114 493.940613,168.132904 C483.480042,190.908310 472.846436,213.608719 461.929352,236.168350 C455.087036,250.307632 447.550690,264.109802 440.415833,278.109131 C434.591125,289.537781 428.898468,301.033691 423.155579,312.503967 C422.940948,312.932556 422.939178,313.533295 422.627380,313.838074 C414.556244,321.726929 418.367767,329.701050 422.327576,337.762421 C427.344482,347.975800 432.145325,358.295654 437.193756,368.493134 C445.742493,385.760773 454.662018,402.849121 462.970825,420.230286 C474.628601,444.617126 485.686920,469.290649 497.362335,493.668793 C503.780365,507.069550 511.212463,519.984314 517.643494,533.379333 C520.769775,539.890869 520.510803,547.620422 512.268799,548.916504 C508.451538,549.516785 503.554657,547.633728 500.095703,545.404663 C480.629211,532.859741 461.336304,520.035645 442.201569,506.987915 C412.443237,486.696045 382.861816,466.144775 353.191345,445.723907 C352.153229,445.009399 350.964447,444.513885 349.640717,443.806702 C315.468567,516.900391 276.016571,587.111450 239.015381,658.986755 z"
    },
    {
        id: 2,
        name: "medium",
        d: "M800.250732,245.247406 C780.855042,264.733215 761.693787,283.953339 742.361328,303.345215 C746.734741,318.459290 751.481384,333.710724 755.515137,349.148438 C759.086975,362.818298 762.038757,376.659302 764.920776,390.496307 C766.338440,397.302643 767.106445,404.255707 767.931030,411.170685 C768.629272,417.025665 766.881165,422.056335 761.044250,424.339386 C755.393494,426.549652 750.673035,423.949402 746.608826,420.098267 C738.797363,412.696381 731.074829,405.200745 723.272095,397.789551 C711.049744,386.180481 698.791443,374.609283 686.222778,362.713867 C677.267273,373.214508 668.494629,383.580322 659.631287,393.868042 C652.651917,401.969025 645.408997,409.846893 638.554932,418.050934 C628.205872,430.438507 618.091614,443.022278 607.881531,455.525909 C604.789917,459.311981 601.800415,463.185883 598.601379,466.878510 C595.575928,470.370819 590.328064,471.599823 586.972046,469.434631 C583.394226,467.126312 582.378479,463.860413 583.944824,459.634644 C588.607178,447.056976 592.999084,434.379272 597.637329,421.792480 C601.783203,410.541626 606.320496,399.431976 610.316589,388.129700 C615.803589,372.610626 621.007996,356.990295 626.198914,341.368652 C628.268738,335.139740 630.161255,328.835419 631.700623,322.460663 C632.008057,321.187500 630.757568,318.793640 629.527466,318.004395 C608.138245,304.281158 585.629333,292.674835 562.276550,282.653595 C551.369507,277.973145 540.612122,272.941101 529.827637,267.979828 C525.360535,265.924835 523.618469,262.155579 525.116882,256.522156 C526.130981,252.709549 529.319641,251.305481 533.309509,250.928314 C545.312866,249.793625 557.262817,248.068039 569.273987,247.048004 C595.608887,244.811523 620.946350,237.593369 646.574829,231.845901 C648.276062,231.464401 650.299927,229.448441 650.911011,227.740845 C660.066467,202.157043 668.774719,176.411057 678.132629,150.903000 C681.313538,142.232315 685.838623,134.029999 690.083618,125.785690 C691.990784,122.081619 695.034424,122.096039 697.252197,125.855591 C699.836670,130.236618 702.196777,134.850937 703.900269,139.632629 C710.108398,157.059647 715.953735,174.615540 722.038879,192.086975 C724.350098,198.723053 726.940002,205.262100 729.486694,212.069397 C744.759460,208.159729 759.953247,204.313141 775.123413,200.375809 C793.283447,195.662476 811.419495,190.856842 829.575256,186.126892 C833.171082,185.190079 839.736572,188.129166 841.847961,191.486267 C844.001221,194.909927 843.348511,200.983673 839.889526,204.554138 C829.633484,215.140686 819.180603,225.536346 808.845154,236.046341 C805.986145,238.953644 803.267883,241.999466 800.250732,245.247406 z"
    },
    {
        id: 3,
        name: "small",
        d: "M657.289001,670.700928 C663.506226,681.628540 669.451050,692.279236 675.459839,702.893738 C682.482910,715.299805 689.604553,727.650269 696.593201,740.075623 C699.043274,744.431641 698.944702,748.955261 695.608887,752.736694 C692.415344,756.356995 688.206787,757.055420 683.647461,755.197693 C672.850342,750.798584 662.035400,746.443481 651.237671,742.046021 C639.694458,737.344910 628.162842,732.615479 616.823975,727.979370 C612.185852,737.634827 607.594482,747.141968 603.047791,756.670410 C596.348755,770.709106 589.890442,784.867493 582.931458,798.775757 C577.830444,808.970764 572.257263,818.942444 566.553955,828.816956 C564.210693,832.874084 559.619568,832.681030 555.846375,831.760559 C552.128967,830.853638 549.229797,828.081909 549.035339,823.797058 C548.585938,813.894470 548.279175,803.984863 547.983337,794.076050 C547.616028,781.771606 546.911499,769.458862 547.095520,757.160889 C547.314575,742.516052 548.289307,727.881531 549.011169,713.246155 C549.186951,709.680176 550.118286,706.080933 549.761108,702.593384 C549.615356,701.170288 547.165039,699.534363 545.423767,698.799133 C536.578308,695.064392 527.589661,691.670715 518.711121,688.012085 C505.118286,682.410706 491.487061,676.888123 478.041626,670.948425 C469.672333,667.251038 469.156311,658.334167 477.004486,653.582458 C493.055756,643.864502 509.289917,634.448303 525.465698,624.936584 C535.700928,618.917969 545.990356,612.990784 556.178101,606.893311 C557.079407,606.353882 557.798584,604.902039 557.931091,603.793640 C558.436584,599.565857 558.828003,595.310547 558.969727,591.055786 C559.388550,578.482056 559.613586,565.901855 560.026306,553.327820 C560.215088,547.576965 560.702332,541.836487 560.983765,536.087891 C561.147522,532.741516 560.923401,529.160522 565.312439,528.298157 C569.516541,527.472107 573.473755,527.620361 576.031494,531.945984 C582.141663,542.279907 588.337524,552.563171 594.436890,562.903442 C597.118469,567.449524 599.592529,572.118103 602.275879,576.663208 C603.381775,578.536255 604.697266,578.981079 606.947388,577.634155 C623.898132,567.487183 640.967346,557.538452 657.975220,547.486694 C667.928467,541.604248 677.651184,535.291443 687.876831,529.934143 C691.025635,528.284485 696.058533,527.822815 699.226257,529.171570 C704.203003,531.290527 705.363586,536.000488 703.162537,541.275757 C699.039246,551.157654 694.495789,560.865967 690.048096,570.610535 C682.199829,587.805847 674.314575,604.984497 666.401184,622.150024 C661.516785,632.745056 656.716797,643.385071 651.520630,653.826599 C649.988220,656.906006 650.069641,658.988525 652.088135,661.685059 C654.076355,664.341187 655.419006,667.480530 657.289001,670.700928 z"
    }
];

export const linkIcons = [
    {
        id: 0,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    },
    {
        id: 1,
        name: "email",
        href: "mailto:maeganalucas@gmail.com",
        class: "email-icon",
        d: "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"
    },
    {
        id: 2,
        name: "github",
        href: "https://www.github.com/maeganlucas",
        class: "github-icon",
        d: "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8"
    },
    {
        id: 3,
        name: "linkedin",
        href: "https://www.linkedin.com/in/maegan-lucas",
        class: "linked-in-icon",
        d: "M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"
    },
    {
        id: 4,
        name: 'download',
        class: "download-icon",
        d1: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5",
        d2: "M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"
    }
];

export const experienceIcons = [
    {
        id: 0,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
    },
    {
        id: 1,
        name: "location",
        class: "location-icon",
        d: "M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
    },
    {
        id: 2,
        name: "calendar",
        class: "calendar-icon",
        d: "M16 5h-6a1 1 0 0 0 0 2h6v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-4h6a1 1 0 0 0 0-2H0V3h16zm-2-5a2 2 0 0 1 2 2H0a2 2 0 0 1 2-2z"
    }
]

export const skillIcons = {
    "Adobe Photoshop": {
        src: require("../assets/images/skills/adobePhotoshop.png")
    },
    "Affinity": {
        src: require("../assets/images/skills/affinity.png")
    },
    "Android": {
        src: require("../assets/images/skills/android.png")
    },
    "Artifactory": {
        src: require("../assets/images/skills/artifactory.png")
    },
    "Bitbucket": {
        src: require("../assets/images/skills/bitbucket.png")
    },
    "Bootstrap": {
        src: require("../assets/images/skills/bootstrap.png")
    },
    "Butter": {
        src: require("../assets/images/skills/butter.png")
    },
    "Canva": {
        src: require("../assets/images/skills/canva.png")
    },
    "Confluence": {
        src: require("../assets/images/skills/confluence.svg").default
    },
    "C#": {
        src: require("../assets/images/skills/csharp.png")
    },
    "CSS": {
        src: require("../assets/images/skills/css.svg").default
    },
    "DBeaver": {
        src: require("../assets/images/skills/dbeaver.png")
    },
    "Figma": {
        src: require("../assets/images/skills/figma.png")
    },
    "Flask": {
        src: require("../assets/images/skills/flask.png")
    },
    "GitHub": {
        src: require("../assets/images/skills/github.png")
    },
    "GitHub Desktop": {
        src: require("../assets/images/skills/githubDesktop.png")
    },
    "HTML": {
        src: require("../assets/images/skills/html.png")
    },
    "IntelliJ": {
        src: require("../assets/images/skills/intelliJ.png")
    },
    "iOS": {
        src: require("../assets/images/skills/ios.png")
    },
    "Java": {
        src: require("../assets/images/skills/java.png")
    },
    "JavaScript": {
        src: require("../assets/images/skills/JavaScript.png")
    },
    "Jenkins": {
        src: require("../assets/images/skills/jenkins.png")
    },
    "Jira": {
        src: require("../assets/images/skills/jira.png")
    },
    ".NET MAUI": {
        src: require("../assets/images/skills/netmaui.png")
    },
    "PyCharm": {
        src: require("../assets/images/skills/pycharm.png")
    },
    "Python": {
        src: require("../assets/images/skills/python.png")
    },
    "React.js": {
        src: require("../assets/images/skills/react.png")
    },
    "Sass": {
        src: require("../assets/images/skills/sass.png")
    },
    "Scrumwise": {
        src: require("../assets/images/skills/scrumwise.png")
    },
    "SonarQube": {
        src: require("../assets/images/skills/sonarqube.svg").default
    },
    "Sourcetree": {
        src: require("../assets/images/skills/sourcetree.png")
    },
    "SQL": {
        src: require("../assets/images/skills/sql.png")
    },
    "Swift": {
        src: require("../assets/images/skills/swift.png")
    },
    "Visual Studio": {
        src: require("../assets/images/skills/visualStudio.png")
    },
    "VS Code": {
        src: require("../assets/images/skills/vsCode.png")
    },
    "XAML": {
        src: require("../assets/images/skills/xaml.png")
    },
    "Xcode": {
        src: require("../assets/images/skills/xcode.png")
    },
    "XML": {
        src: require("../assets/images/skills/xml.png")
    }
}